export enum PendingImplementation {
  PrePay = 0,
  PostPay = 1,
  PreTeamPostSolo = 2
}

export const PendingImplementationMapping: Record<PendingImplementation, string> = {
  [PendingImplementation.PrePay]: 'Pre-Pay',
  [PendingImplementation.PostPay]: 'Post Pay',
  [PendingImplementation.PreTeamPostSolo]: 'Post Pay Solo, Pre Pay Team'
};
